import { redirect } from "@tanstack/react-router";

import type { FeatureFlags } from "@/lib/launchdarkly";

type LinkedScheduleFlags = Pick<
  FeatureFlags,
  "abre-agenda-vinculada-ao-criar-periodo-garantido"
>;

export const LINKED_SCHEDULE_STEP_PATH =
  "/settings/reserved-schedules/create/linked-schedule";
export const CONFIRM_STEP_PATH = "/settings/reserved-schedules/create/confirm";

/**
 * O passo "abrir agenda para este período" (KRA-447) entra no wizard de criação do PG **só** com a
 * flag ligada. `=== true` de propósito: no contexto de teste a chave pode nem existir, e ausente
 * tem que ler como desligada.
 */
export const usesLinkedScheduleStep = (flags: LinkedScheduleFlags): boolean =>
  flags["abre-agenda-vinculada-ao-criar-periodo-garantido"] === true;

/**
 * Para onde a data de início manda: com a flag, o passo da agenda; sem ela, a confirmação, como
 * sempre foi.
 */
export const stepAfterStartingDay = (
  flags: LinkedScheduleFlags,
): typeof LINKED_SCHEDULE_STEP_PATH | typeof CONFIRM_STEP_PATH =>
  usesLinkedScheduleStep(flags) ? LINKED_SCHEDULE_STEP_PATH : CONFIRM_STEP_PATH;

/**
 * Guarda da rota do passo. Com a flag desligada, a data de início nunca manda para cá, então quem
 * chega é link direto ou histórico de antes da flag virar. Sem a guarda, o passo gravaria um pedido
 * de agenda que a confirmação mostraria (e a T11 enviaria).
 *
 * O redirect só dispara **fora** do fluxo normal. Fica no `loader` pelos mesmos motivos de
 * `requireChosenModality`.
 */
export const requireLinkedScheduleStep = (flags: LinkedScheduleFlags): void => {
  if (!usesLinkedScheduleStep(flags)) {
    redirect({ to: CONFIRM_STEP_PATH, throw: true });
  }
};
